import { render, staticRenderFns } from "./Searchbar.vue?vue&type=template&id=348a19d0&scoped=true&"
import script from "./Searchbar.vue?vue&type=script&lang=js&"
export * from "./Searchbar.vue?vue&type=script&lang=js&"
import style0 from "./Searchbar.vue?vue&type=style&index=0&id=348a19d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a19d0",
  null
  
)

export default component.exports